import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../../PageHeader';
import CorporateSectionLayout from '../../../CorporateSectionLayout';
import ImplementasiPelaksanaanGCG from './ImplementasiPelaksanaanGCG';
import AssessmentImprovementGCG from './AssessmentImprovementGCG';

function ImplementasiGCGLayout() {
    const items = [
        { id: 'implementasi-pelaksanaan-gcg', number: '01', label: 'Implementasi Pelaksanaan GCG', content: <ImplementasiPelaksanaanGCG /> },
        { id: 'assessment-improvement-gcg', number: '02', label: 'Assessment & Improvement GCG', content: <AssessmentImprovementGCG /> },
    ];
    return <>
        <Helmet><title>Implementasi GCG | PT Len Telekomunikasi Indonesia</title><meta name="description" content="Implementasi GCG PT Len Telekomunikasi Indonesia." /><link rel="canonical" href="https://www.len-telko.co.id/tata-kelola-perusahaan/implementasi-gcg" /></Helmet>
        <PageHeader title="Implementasi GCG" />
        <CorporateSectionLayout title="Implementasi GCG" eyebrow="Tata Kelola Perusahaan" items={items} />
    </>;
}
export default ImplementasiGCGLayout;
